import { afterNextRender, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { PrimeNGModule } from '../../primeng.module';
import { AuthService } from '../../services/auth/auth.service';
import { BudgetService } from '../../services/budget/budget.service';
import { CartService } from '../../services/cart/cart.service';
import { LoaderService } from '../../services/loader/loader.service';
import { ToastService } from '../../services/toast/toast.service';
import { UserService } from '../../services/user/user.service';
import { BreadcrumbComponent } from '../../shared/components/breadcrumb/breadcrumb.component';
import { HasNoItensComponent } from '../../shared/components/has-no-itens/has-no-itens.component';
import Budget from '../../shared/models/budget/budget';
import User from '../../shared/models/user/user';
import { SharedModule } from '../../shared/shared.module';
import { PaymentService } from './../../services/payment/payment.service';
import { CartItem } from './../../shared/models/cart/cart';

@Component({
  selector: 'app-budget',
  standalone: true,
  imports: [
    BreadcrumbComponent,
    PrimeNGModule,
    SharedModule,
    HasNoItensComponent,
  ],
  templateUrl: './budget.component.html',
  styleUrl: './budget.component.scss',
  providers: [ToastService, MessageService],
})
export class BudgetComponent implements OnInit {
  public budget?: Budget;
  public user: User | undefined = new User();
  public isMobile = false;
  public installments: number[] = [];

  constructor(
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private budgetService: BudgetService,
    private cartService: CartService,
    private paymentService: PaymentService,
    private loaderService: LoaderService,
    private userService: UserService,
    private toastService: ToastService
  ) {
    this.loaderService.show();
    this.authService.userData$.subscribe((res: any) => {
      this.user = undefined;
      if (res) {
        this.user = new User();
        this.user.fromJson(res);
      }
    });

    afterNextRender(() => {
      this.isMobile = window?.innerWidth < 640;
    });
  }
  ngOnInit() {
    this.init();
  }

  async init() {
    this.configBudget();
  }

  async configBudget() {
    try {
      const hashBudget =
        this.activatedRoute.snapshot.paramMap.get('hashBudget') || '';
      this.budget = await this.budgetService.get(hashBudget);
      if (this.budget?.cart) {
        this.cartService.setAuxVariables(this.budget.cart, undefined);
        this.getAllInstallment();
      }

      this.activatedRoute.queryParams.subscribe(async (params) => {
        const rawErrorMsg = params['errorMsg'];
        const errorMsg = rawErrorMsg ? decodeURIComponent(rawErrorMsg) : null;
        if (errorMsg) {
          this.toastService.error(errorMsg, 5000);
        }
      });
    } catch (err: any) {
    } finally {
      this.loaderService.hide();
    }
  }

  getTotalWeight(): string {
    let totalWeight = 0;

    this.budget?.cart?.cartProducts?.forEach((item: CartItem) => {
      const { product, customHeight, customWidth, amount } = item;

      const squareMeters = product?.productPerSquareMeter
        ? (customHeight || 0) * (customWidth || 0) * (amount || 0)
        : 1 * (amount || 0);

      totalWeight += (product?.weight || 0) * squareMeters;
    });

    return `${totalWeight.toFixed(2)}kg`;
  }

  getAllInstallment() {
    const total =
      (this.budget?.cart?.valueTotal || 0) +
      (this.budget?.cart?.valueDiscountSeller || 0) +
      (this.budget?.additionalValue || 0) -
      (this.budget?.availableCredit || 0);
    if (total > 0) {
      const installments = this.paymentService.getInstallments(total);
      this.installments = installments;
    }
  }

  getInstallmentValue(installment: number) {
    return this.installments[installment - 1];
  }

  getValueItem(cartProduct: CartItem, whithDiscount: boolean) {
    return this.cartService.getValueItem(cartProduct, whithDiscount);
  }

  async onClickCheckout() {
    this.userService.goToPayment(this.budget || null);
  }
}
